import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=7464aa52&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=7464aa52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7464aa52",
  null
  
)

export default component.exports